<script lang="ts">
  import Arrow from '$icons/ArrowIcon.svelte';
  import GlobalTextInput from './GlobalTextInput.svelte';
  import SimpleCaption from './SimpleCaption.svelte';

  import { createEventDispatcher } from 'svelte';

  export let value;
  export let required: boolean = false;
  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let disabled: boolean = false;

  const dispatch = createEventDispatcher();

  $: {
    value, label;
    dispatch('change', { value, label });
  }

  function handleSubmit() {
    // dispatch('change', value);
  }
</script>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-garden-grey-600 font-medium text-sm" for="">
    {label ?? ''}
    <span class="text-red-500">*</span>
  </label>
  <div class="flex flex-row gap-0 items-center min-h-[54px] w-full">
    <div
      class:input-danger={danger}
      class="text border border-r-0 rounded-r-none border-garden-grey-300 rounded-14 p-4 text-garden-grey-500 text-center items-center"
    >
      <slot>
        <div class="flex flex-row justify-center items-center gap-1">
          <span>Text</span>
          <span><Arrow /></span>
        </div>
      </slot>
    </div>

    <GlobalTextInput
      {disabled}
      unround="l"
      {danger}
      {placeholder}
      hideCaption
      bind:value
      on:blur
      on:focus
      on:submit={handleSubmit}
    />
  </div>
  <SimpleCaption {danger} {dangerMessage} {caption} variant={'styled'} />
</div>

<style type="postcss">
  .input-danger {
    @apply border-accent-red-40;
  }
  .input-danger:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ffecec;
  }

  .text {
    background: linear-gradient(180deg, #fbfefd 0%, #f8fdfb 100%);
  }
</style>
